import React, { useEffect, useState } from 'react';
import ResetPasswordCard from '@components/auth/ResetPasswordCard';

import { useNavigate, useParams } from 'react-router-dom';
import { IUserResetPasswordTokenReq } from '@models/interfaces/user.interface';
import userService from '@services/GeniebookAPI/UserServices.services';
import Cookies from 'js-cookie';
import login from '@illustrations/auth/login.json';
import GeniebookLogo from '@assets/illustration/auth/geniebook-logo';
import AuthLayout from '@layouts/AuthLayout';
import { Helmet } from 'react-helmet-async';
import { LoadingScroll } from 'geniebook-ui/dist';
import ErrorPage from '@pages/error/ErrorPage';
import NavyBlueBackground from '@layouts/NavyBlueBackground';
import SkyBlueBackground from '@layouts/SkyBlueBackground';
import {
  ContainerForm,
  PhoneIllustrationDiv,
  TabletIllustrationDiv,
} from './styles/Auth.style';
import axios from 'axios';

const ResetPasswordPage = () => {
  const check = Cookies.get('uid');
  const navigate = useNavigate();
  const { token } = useParams();

  const [loading, setLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorCode, setErrorCode] = useState<
    '500' | '404' | '099-03' | '103-09' | 'no-subscription' | undefined
  >('500');

  useEffect(() => {
    if (check) {
      navigate('/');
    }

    const params: IUserResetPasswordTokenReq = {
      reset_token: token || '',
    };
    checkTokenValid(params);
  }, []);

  const checkTokenValid = async (data: IUserResetPasswordTokenReq) => {
    setLoading(true);
    try {
      await userService.validateResetPasswordToken(data);
    } catch (error: unknown) {
      setIsError(true);
      const error_code = axios.isAxiosError(error)
        ? error.response?.data?.error_code
        : '';
      if (error_code === '' || error_code === undefined) {
        setErrorCode('500');
      } else {
        setErrorCode(error_code);
      }
    } finally {
      setLoading(false);
    }
  };

  return loading ? (
    <>
      <Helmet>
        <title>Geniebook - Reset Password</title>
        <meta name="description" content="Reset Password" />
      </Helmet>
      <NavyBlueBackground>
        <LoadingScroll isBlockOthers={true} />
      </NavyBlueBackground>
    </>
  ) : isError ? (
    <>
      <Helmet>
        <title>Geniebook - Reset Password</title>
        <meta name="description" content="Reset Password" />
      </Helmet>
      <NavyBlueBackground>
        <div className="h-screen w-full">
          <ErrorPage code={errorCode} />
        </div>
      </NavyBlueBackground>
    </>
  ) : (
    <>
      <Helmet>
        <title>Geniebook - Reset Password</title>
        <meta name="description" content="Reset Password" />
      </Helmet>
      <SkyBlueBackground>
        <AuthLayout illustration={login}>
          <div className="w-full">
            <TabletIllustrationDiv />
            <PhoneIllustrationDiv />
            <ContainerForm>
              <div className="text-left px-[38px] max-sm:px-[24px] lg:min-w-[343px]">
                <div className="mb-[32px] lg:hidden">
                  <GeniebookLogo className="w-[155px] h-[24px]" />
                </div>
                <div className="w-full">
                  <ResetPasswordCard />
                </div>
              </div>
            </ContainerForm>
          </div>
        </AuthLayout>
      </SkyBlueBackground>
    </>
  );
};

export default ResetPasswordPage;
